// Reusable filter options and helpers for notifications
// Decoupled from Redux; used by both hooks and UI components

export const notificationFilterOptions = [
  { value: '0', label: 'globals.new', fnc: (item) => item?.isRead === 0 },
  { value: '1', label: 'globals.all', fnc: (item) => !!item },
  { value: '6', label: 'globals.tasks', fnc: (item) => !!item },
  { value: '3', label: 'globals.discussions', fnc: (item) => !!item },
  { value: '10', label: 'globals.sales', fnc: (item) => !!item },
  { value: '4', label: 'globals.archived', fnc: (item) => item?.isRead === 1 },
];

// Map UI filter values to backend-supported `types` param.
// Only '3', '6', '10' are supported by backend; other types require client-side filtering.
export const serverTypesFor = (filterType) => {
  const t = String(filterType);
  return ['3', '6', '10'].includes(t) ? t : undefined;
};

// const allTypes = [
//   {"key": "NOTIFICATION_ADDED_TO_CIRCLE", "value": 1},
//   {"key": "NOTIFICATION_TASK_FEEDBACK", "value": 2},
//   {"key": "NOTIFICATION_POST_ADDED", "value": 3},
//   {"key": "NOTIFICATION_TASK_ASSESSED", "value": 4},
//   {"key": "NOTIFICATION_YOU_MENTIONED", "value": 5},
//   {"key": "NOTIFICATION_FEEDBACK_REQUIRED", "value": 6},
//   {"key": "NOTIFICATION_UNREVIEWED_TASKS", "value": 7},
//   { "key": "NOTIFICATION_THREAD_NEW_POSTS", "value": 8},
//   {"key": "NOTIFICATION_COURSE_NEW_POSTS", "value": 9},
//   {"key": "NOTIFICATION_COURSE_SOLD", "value": 10},
//   {"key": "NOTIFICATION_COURSE_PACKAGE_SOLD", "value": 11},
//   {"key": "NOTIFICATION_ADDED_TO_COURSE", "value": 12},
//   {"key": "NOTIFICATION_WE_MISS_YOU", "value": 13},
//   {"key": "NOTIFICATION_DRIP_CONTENT_AVAIL", "value": 14},
//   {"key": "NOTIFICATION_EXPORT_COMPLETE", "value": 15},
//   {"key": "NOTIFICATION_YOU_INVITED", "value": 16},
//   {"key": "NOTIFICATION_SHORT_LIFE", "value": 17},
//   {"key": "NOTIFICATION_SYSTEM_ERROR", "value": 18}
// ]
